 <template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Send coupons form</h1>
          <h2 class="subtitle">
            With this form you can send your deals to offerte.club network - if you sell products and you have a coupon code, this is the right place to contact us.
            <br />We will review your coupon deal and if it is appropriate, we will publish it on our channels, for free.
          </h2>
        </div>
      </div>
    </section>

    <div class="container" style="margin-top: 30px">

      <div class="columns">
        <div class="column">
          <CouponForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CouponForm from "./CouponForm.vue";

export default {
  name: "SendCoupon",
  components: {
    CouponForm
  },
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  },
};
</script>
